import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type", "id", "container", "search", "results", "summary"];
  static values = {
    preselectedType: String,
    preselectedId: String,
    preselectedName: String,
  };

  connect() {
    if (this.hasPreselectedTypeValue && this.hasPreselectedIdValue) {
      // If we have pre-selected values, show the summary and hide the selects
      this.showSummary();
      this.hideSelects();
    }
  }

  showSummary() {
    if (this.hasSummaryTarget) {
      this.summaryTarget.classList.remove("hidden");
      this.containerTarget.classList.add("hidden");
      this.typeTarget.closest("div").classList.add("hidden");
    }
  }

  hideSelects() {
    this.containerTarget.classList.add("hidden");
    this.typeTarget.closest("div").classList.add("hidden");
  }

  showSelects() {
    if (this.hasSummaryTarget) {
      this.summaryTarget.classList.add("hidden");
    }
    this.containerTarget.classList.remove("hidden");
    this.typeTarget.closest("div").classList.remove("hidden");
  }

  updateOptions() {
    const type = this.typeTarget.value;
    if (!type) {
      this.containerTarget.style.display = "none";
      this.resultsTarget.classList.add("hidden");
      return;
    }

    this.containerTarget.style.display = "block";
    this.searchTarget.value = "";
    this.idTarget.value = "";
    this.resultsTarget.classList.add("hidden");
  }

  search() {
    const type = this.typeTarget.value;
    const query = this.searchTarget.value.trim();

    if (!type || !query) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Debounce the search
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.performSearch(type, query);
    }, 300);
  }

  async performSearch(type, query) {
    try {
      const response = await fetch(
        `/api/v1/rateables?type=${type}&query=${encodeURIComponent(query)}`
      );
      const data = await response.json();

      this.resultsTarget.innerHTML = "";
      if (data.length === 0) {
        this.resultsTarget.classList.add("hidden");
        return;
      }

      const resultsList = document.createElement("ul");
      resultsList.className = "divide-y divide-gray-100";

      data.forEach((item) => {
        const li = document.createElement("li");
        li.className = "px-4 py-2 hover:bg-gray-50 cursor-pointer";
        li.textContent = item.name;
        li.addEventListener("click", () => this.selectItem(item));
        resultsList.appendChild(li);
      });

      this.resultsTarget.appendChild(resultsList);
      this.resultsTarget.classList.remove("hidden");
    } catch (error) {
      console.error("Error searching rateables:", error);
      this.resultsTarget.classList.add("hidden");
    }
  }

  selectItem(item) {
    this.idTarget.value = item.id;
    this.searchTarget.value = item.name;
    this.resultsTarget.classList.add("hidden");
  }

  editSelection() {
    this.showSelects();
    this.updateOptions();
  }
}
